import React from "react";
import {
    IApplicationInternal, IApplicationToken,
    IScope
} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Values} from "Tools/Values";
import {IApplicationsStore} from "Stores/Applications/types";
import {InternalAppDialogForm} from "./InternalAppDialogForm/InternalAppDialogForm";
import {IFile} from "@src/Interfaces/Entity/File";
import {observable} from "mobx";
import management from "Stores/Management";
import {IManagementStore} from "Stores/Management/types";
import {IValuesStore} from "Stores/Values/types";
import {inject, observer} from "mobx-react";

interface IProps {
    onClose: () => void;
    onConfirm: (app: IApplicationInternal) => void;
    onTokenRefresh?: (token: IApplicationToken) => void;
    isOpened: boolean;
    isEdit: boolean;
    scopes: IScope[];
    app?: IApplicationInternal;
    applicationsStore?: IApplicationsStore;
    management?: IManagementStore;
    values?: IValuesStore
}

@inject("values", "management", "applicationsStore")

@observer
export class InternalAppDialog extends React.Component<IProps> {
    @observable dataFormRef: any;

    onConfirm() {
        setTimeout(() => {
            this.dataFormRef.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}))
        }, 20);
    }

    async onSubmit(data: any) {
        try {
            let id = this.props.app?.clientId;

            if (!this.props.isEdit) {
                const newApplication = await this.props.applicationsStore.createInternalApplication(data);
                id = newApplication?.clientId;
            }

            if (data.imageFile?.name === 'reset') {
                data.image = '';
            } else if (data.imageFile !== null) {
                const file: IFile = await this.props.management.uploadFile(
                    data.imageFile,
                    id,
                    this.props.values.fileTypes.InternalApplicationImage
                );

                data.image = file.url;
            }

            const updatedApplication = await this.props.applicationsStore.updateInternalApplication(data, id);
            this.props.onConfirm(updatedApplication);
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        return (
            <Dialog
                maxWidth="lg"
                open={this.props.isOpened}
                onClose={() => this.props.onClose()}
            >
                <DialogTitle>
                    {this.props.isEdit
                        ? Values.getLocalizationValue('modifyInternalApp')
                        : Values.getLocalizationValue('addNewInternalApp')
                    }
                </DialogTitle>

                <DialogContent style={{minWidth: 500, paddingBottom: 32}}>
                    <InternalAppDialogForm
                        initialValues={this.props.app}
                        scopes={this.props.scopes}
                        isEdit={this.props.isEdit}
                        setRef={ref => this.dataFormRef = ref}
                        onSubmit={(data) => this.onSubmit(data)}
                        onTokenRefresh={this.props.onTokenRefresh}
                    />
                </DialogContent>

                <DialogActions style={{padding: 16}}>
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={this.props.onClose}
                    >
                        {Values.getLocalizationValue('cancel')}
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.onConfirm()}
                    >
                        {Values.getLocalizationValue('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
